import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Works in addition to MigrationSideNavComponent
 *
 * @deprecated this service should not be used in MFE repo. It was created just as a routing workaround.
 */
@Injectable({
	providedIn: 'root'
})
export class MigrationExpandComponentService {
	private componentChange = new BehaviorSubject<Type<any>>(null);
	public componentChange$: Observable<Type<any>> = this.componentChange.asObservable();

	constructor() {
	}

	/**
	 * @param component to expand over side-nav and its content. See implementation of MigrationSideNavComponent
	 */
	expandComponent(component: Type<any>): void {
		this.componentChange.next(component);
	}

	/**
	 * Make visible sive-nav and its content visible again in MigrationSideNavComponent.
	 */
	backToDefaultView(): void {
		this.componentChange.next(null);
	}
}
